import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row p-1" };
const _hoisted_2 = { class: "col" };
const _hoisted_3 = {
    key: 0,
    class: "form-group row"
};
const _hoisted_4 = { class: "col-2 mb-0 control-label" };
const _hoisted_5 = { class: "col-md-10" };
const _hoisted_6 = { class: "form-group row align-items-center" };
const _hoisted_7 = { class: "col-2 mb-0 control-label" };
const _hoisted_8 = { class: "col-md-10" };
const _hoisted_9 = { class: "form-group row align-items-center" };
const _hoisted_10 = { class: "col-2 mb-0 control-label" };
const _hoisted_11 = { class: "col-md-10" };
const _hoisted_12 = { class: "col-2 mb-0 control-label" };
const _hoisted_13 = { class: "col-md-10" };
const _hoisted_14 = ["placeholder"];
const _hoisted_15 = {
    key: 0,
    class: "error form-group__message"
};
const _hoisted_16 = {
    key: 1,
    class: "error form-group__message"
};
const _hoisted_17 = { class: "modal-footer" };
const _hoisted_18 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createVNode($setup["BModal"], {
            ref: "editJoinLinkUsersModal",
            "no-footer": "",
            centered: "",
            size: "lg",
            title: _ctx.$t('JTADM_JOIN_LINK_UPDATE')
        }, {
            default: _withCtx(() => [
                ($setup.selection)
                    ? (_openBlock(), _createBlock($setup["BContainer"], {
                        key: 0,
                        fluid: ""
                    }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createElementVNode("div", _hoisted_2, [
                                    ($setup.currentUserStore.tenantId)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('JTADM_USERS_TENANT')), 1),
                                            _createElementVNode("div", _hoisted_5, _toDisplayString($setup.currentUserStore.tenantName), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('JTADM_HOSPITAL')), 1),
                                        _createElementVNode("div", _hoisted_8, _toDisplayString($setup.selection.hospitalName), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_9, [
                                        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('JTADM_USER')), 1),
                                        _createElementVNode("div", _hoisted_11, _toDisplayString($setup.selection.userName), 1)
                                    ]),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["form-group row align-items-center", { 'form-group--error': $setup.v$.jid.$error }])
                                    }, [
                                        _createElementVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('JTADM_JOIN_CHAT_ID')), 1),
                                        _createElementVNode("div", _hoisted_13, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-control form__input",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.selection.jid) = $event)),
                                                type: "text",
                                                placeholder: _ctx.$t('JTADM_JOIN_CHAT_ID'),
                                                onInput: _cache[1] || (_cache[1] =
                                                    //@ts-ignore
                                                    (...args) => ($setup.v$.jid.$touch && $setup.v$.jid.$touch(...args)))
                                            }, null, 40, _hoisted_14), [
                                                [
                                                    _vModelText,
                                                    $setup.selection.jid,
                                                    void 0,
                                                    { trim: true }
                                                ]
                                            ]),
                                            ($setup.v$.jid.$error && $setup.v$.jid.required.$invalid)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('JTADM_JIDS_JID_REQUIRED')), 1))
                                                : ($setup.v$.jid.$error && $setup.v$.jid.minLength.$invalid)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                                                    : _createCommentVNode("", true)
                                        ])
                                    ], 2)
                                ])
                            ])
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                _createElementVNode("footer", _hoisted_17, [
                    ($setup.selection)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "btn btn-success",
                            type: "submit",
                            disabled: $setup.selection.jid === $setup.joinLinkUsersJid,
                            onClick: _withModifiers($setup.updateJoinLink, ["prevent"])
                        }, _toDisplayString(_ctx.$t('JTADM_UPDATE')), 9, _hoisted_18))
                        : _createCommentVNode("", true),
                    _createElementVNode("button", {
                        class: "btn btn-danger",
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => ($setup.editJoinLinkUsersModal?.hide()), ["prevent"]))
                    }, _toDisplayString(_ctx.$t('JTADM_CANCEL')), 1)
                ])
            ]),
            _: 1
        }, 8, ["title"])
    ]));
}
